import { render } from "./VehicalRequest.vue?vue&type=template&id=668836dc&scoped=true"
import script from "./VehicalRequest.vue?vue&type=script&lang=js"
export * from "./VehicalRequest.vue?vue&type=script&lang=js"

import "./VehicalRequest.vue?vue&type=style&index=0&id=668836dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668836dc"]])

export default __exports__